import { t } from 'i18next'
import FormLayout from 'src/app/layout/form-layout/form-layout'
import { FormLayoutDefaultToolbar } from 'src/app/layout/form-layout/form-layout-toolbar'
import { FormLayoutAppearance } from 'src/app/layout/form-layout/form-layout.types'
import { Grid, Typography } from '@mui/material'
import i18n from 'src/locales/i18n'
import { Stack } from '@vapor/material'
import RREditChargeCategoriesGrid from './grid/rr-bulk-edit-charge-categories-grid'
import useRRBulkEditCCGridRows from './grid/utils/rr-bulk-edit-cc-grid-rows'
import useRRBulkEditChargeCategoryGridCRUD from './grid/utils/rr-bulk-edit-charge-category-grid-crud'
import { ReservedResourceF } from '../../../types/reservation-detail.types'

type RRBulkEditChargeCategoriesFormProps = {
  appearance: FormLayoutAppearance
  propertyId: string
  reservation: {
    groupName?: string
    start?: Date
    end?: Date
  }
  reservedResources: ReservedResourceF[]
  onBack: () => void
  onSuccess?: () => Promise<void>
}

export default function RRBulkEditChargeCategoriesForm(props: RRBulkEditChargeCategoriesFormProps) {
  const { appearance, propertyId, reservedResources, reservation, onBack, onSuccess } = props

  const { loading, stayIncludedCC, updateRRs } = useRRBulkEditChargeCategoryGridCRUD(propertyId, onSuccess)
  const { rows, summaryRow, updateRow, updateRows } = useRRBulkEditCCGridRows(reservation?.start ?? new Date(), reservation?.end ?? new Date(), reservedResources, stayIncludedCC)

  return (
    <FormLayout
      title={t('pms.booking.reservation.rr_bulk_edit_cc_drawer.title')}
      appearance={appearance}
      toolbar={
        <FormLayoutDefaultToolbar //
          saveButton={{ clickHandler: () => updateRRs(rows), text: t('commons.save'), loading: loading, disabled: loading }}
          cancelButton={{ clickHandler: onBack, text: t('commons.cancel'), disabled: loading }}
        />
      }
    >
      <Stack direction="column" spacing={1}>
        {reservation.groupName && <Typography variant="body">{reservation.groupName}</Typography>}
        {reservation.start && reservation.end && (
          <Typography variant="body">
            {reservation.start.toLocaleDateString(i18n.language, { weekday: 'short', day: '2-digit', month: 'long', year: 'numeric' })} →{' '}
            {reservation.end.toLocaleDateString(i18n.language, { weekday: 'short', day: '2-digit', month: 'long', year: 'numeric' })}
          </Typography>
        )}
        <Grid container>
          <Grid item xs={12}>
            {reservation.start && reservation.end && (
              <RREditChargeCategoriesGrid
                disabled={loading}
                start={reservation.start}
                end={reservation.end}
                reservedResources={reservedResources}
                propertyId={propertyId}
                rows={rows}
                summaryRow={summaryRow}
                updateRow={updateRow}
                updateRows={updateRows}
                chargeCategories={stayIncludedCC}
              />
            )}
          </Grid>
        </Grid>
      </Stack>
    </FormLayout>
  )
}
